import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgT4 = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 81 80",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		transform: "translate(2 18)",
		fill: "none",
		fillRule: "evenodd",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M34.247 0a4.994 4.994 0 014.67 3.214h0l8.914 23.31a10.01 10.01 0 014.707 3.262 9.153 9.153 0 012.01 5.714c0 2.63-1.124 5.013-2.95 6.737C49.795 43.942 47.304 45 44.549 45c-2.754 0-5.246-1.058-7.05-2.763-1.6-1.511-2.662-3.53-2.9-5.776h0l-10.112-.42c-.227 2.414-1.261 4.505-2.813 6.059-1.81 1.814-4.333 2.9-7.125 2.9-2.754 0-5.246-1.058-7.05-2.763-1.615-1.525-2.68-3.565-2.906-5.836h0l-3.656-.402a1.993 1.993 0 01-1.35-.585A1.994 1.994 0 01-1 34h0V19c0-.552.224-1.052.586-1.414A1.994 1.994 0 011 17h18V0z",
				stroke: "#0D0E10",
				strokeWidth: 2
			}),
			/* @__PURE__ */ _jsx("rect", {
				fill: "#0D0E10",
				transform: "rotate(30 52.969 22.25)",
				x: 42.469,
				y: 21.25,
				width: 21,
				height: 2,
				rx: 1
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#0D0E10",
				d: "M47.769 24.333l11.876 5.287-.814 1.828-11.876-5.288z"
			}),
			/* @__PURE__ */ _jsx("circle", {
				stroke: "#0D0E10",
				strokeWidth: 2,
				cx: 14.548,
				cy: 35.5,
				r: 3.5
			}),
			/* @__PURE__ */ _jsx("circle", {
				stroke: "#0D0E10",
				strokeWidth: 2,
				cx: 44.548,
				cy: 35.5,
				r: 3.5
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M66.111 19.309a1.994 1.994 0 011.442.516c.379.344.627.832.654 1.384h0l.253 5.193a12.457 12.457 0 005.965 10.033h0l1.804 1.099a1.998 1.998 0 01.14 3.322 1.994 1.994 0 01-1.486.362h0l-10.62-1.647a6 6 0 01-4.579-8.332h0l4.692-10.734a1.998 1.998 0 011.735-1.196z",
				stroke: "#0D0E10",
				strokeWidth: 2
			}),
			/* @__PURE__ */ _jsx("rect", {
				fill: "#0D0E10",
				x: 2,
				y: 20,
				width: 2,
				height: 6,
				rx: 1
			}),
			/* @__PURE__ */ _jsx("rect", {
				fill: "#0D0E10",
				x: 6,
				y: 20,
				width: 2,
				height: 6,
				rx: 1
			}),
			/* @__PURE__ */ _jsxs("g", {
				transform: "rotate(90 8 30)",
				fill: "#0D0E10",
				children: [/* @__PURE__ */ _jsx("rect", {
					width: 2,
					height: 6,
					rx: 1
				}), /* @__PURE__ */ _jsx("rect", {
					x: 4,
					width: 2,
					height: 6,
					rx: 1
				})]
			}),
			/* @__PURE__ */ _jsx("rect", {
				fill: "#0D0E10",
				transform: "rotate(90 25 10)",
				x: 24,
				y: 4,
				width: 2,
				height: 12,
				rx: 1
			}),
			/* @__PURE__ */ _jsx("rect", {
				fill: "#0D0E10",
				transform: "rotate(90 37 17)",
				x: 36,
				y: 10,
				width: 2,
				height: 14,
				rx: 1
			}),
			/* @__PURE__ */ _jsx("rect", {
				fill: "#0D0E10",
				x: 30,
				width: 2,
				height: 18,
				rx: 1
			})
		]
	})
});
export default SvgT4;
